export const PDP_TEMPLATES = {
  WORKSPACE: 'workspace'
};

export const COUNTRY_CODE_REG_EXP = /\(?([A-Z]{2,3})\)?/gm;

export const HIDDEN_CLASS = 'hidden';
